import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'finder-hero-cta-heading',
    templateUrl: './hero-cta-heading.component.html',
    styleUrls: ['./hero-cta-heading.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
    ]
})
export class HeroCtaHeadingComponent {
    @Input() ctaData: any;
    @Input() ctaClass: string;

    constructor() { }

}
